/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQAttemptResponseCorrectAnswers } from './mCQAttemptResponseCorrectAnswers';
import type { MCQAttemptResponseFeedback } from './mCQAttemptResponseFeedback';

/**
 * Result of an MCQ attempt.
 */
export interface MCQAttemptResponse {
  score: number;
  maxScore: number;
  passed: boolean;
  immediateFeedback: boolean;
  correctAnswers: MCQAttemptResponseCorrectAnswers;
  feedback: MCQAttemptResponseFeedback;
}
